if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-sticky-add-to-cart-button]');
        this.textEl = this.querySelector('[data-sticky-add-to-cart-text]');
      }

      connectedCallback() {
        this.realForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');
        this.realButton = this.realForm ? this.realForm.querySelector('button[name="add"]') : null;
        this.observedTarget = document.querySelector('.product-form__buttons') || this.realButton;

        if (this.button) {
          this.clickHandler = this.handleClick.bind(this);
          this.button.addEventListener('click', this.clickHandler);
        }

        if (this.observedTarget && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { rootMargin: '0px' });
          this.observer.observe(this.observedTarget);
        }

        if (this.realButton) {
          this.buttonObserver = new MutationObserver(this.syncButtonState.bind(this));
          this.buttonObserver.observe(this.realButton, { attributes: true, attributeFilter: ['disabled'] });
          this.syncButtonState();
        }
      }

      handleIntersect(entries) {
        const entry = entries[entries.length - 1];
        if (!entry) return;

        if (entry.isIntersecting) {
          this.classList.remove('sticky-add-to-cart--visible');
        } else if (entry.boundingClientRect.top < 0) {
          this.classList.add('sticky-add-to-cart--visible');
        } else {
          this.classList.remove('sticky-add-to-cart--visible');
        }
      }

      syncButtonState() {
        if (!this.realButton || !this.button) return;

        this.button.disabled = this.realButton.disabled;

        if (this.textEl) {
          const realSpan = this.realButton.querySelector('span');
          this.textEl.textContent = (realSpan ? realSpan.textContent : this.realButton.textContent).trim();
        }
      }

      handleClick(event) {
        event.preventDefault();
        if (!this.realButton || this.realButton.disabled) return;
        this.realButton.click();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.button && this.clickHandler) this.button.removeEventListener('click', this.clickHandler);
      }
    }
  );
}
